/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BDUpdateType {
    Added = 'Added',
    Deleted = 'Deleted',
    Updated = 'Updated'
}

export function BDUpdateTypeFromJSON(json: any): BDUpdateType {
    return BDUpdateTypeFromJSONTyped(json, false);
}

export function BDUpdateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BDUpdateType {
    return json as BDUpdateType;
}

export function BDUpdateTypeToJSON(value?: BDUpdateType | null): any {
    return value as any;
}

